import APIService from './APIService';

export default {
  getAtualizacoes() {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get('/atualizacoes-bdgd-via-scripts-modelos/get-atualizacoes')
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error));
    });
  },
  save(data) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .post('/atualizacoes-bdgd-via-scripts-modelos/salvar', JSON.stringify(data))
        .then(() => resolve(true))
        .catch(() => reject(false));
    });
  },
  deletar(id) {
    return APIService.apiCall().get(`/atualizacoes-bdgd-via-scripts-modelos/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/atualizacoes-bdgd-via-scripts-modelos/executar/${id}`);
  },
  baixarZip(id, config = {}) {
    return APIService.apiCall().get(`/atualizacoes-bdgd-via-scripts-modelos/download-arquivo-zip-logs/${id}`, {
      responseType: 'blob',
      ...config
    });
  }
};
